(function () {
    'use strict';

    angular.module("imApp").factory("favoritesService", ['$ihttp', function ($ihttp) {
        let service = {
            listFavourites: function (parms) {
                return $ihttp.post({
                    method: 2235,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
